import { useMutation, useQueryClient } from 'react-query';
import { AxiosResponse } from 'axios';

// configs
import { API } from 'configs/api';
// kyes
import { reactionsQueryKeys } from './reactionsQueryKeys';
// types
import { VideoReactionItem } from './types';
// utils
import { getShortUrlFromUrl } from 'utils/url';

const postReactionCommentsMutation = async ({
  data,
}: {
  data: Partial<VideoReactionItem>;
}) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const response: AxiosResponse = await API.post(
    `/playback/${shortUrl}/reactions`,
    data
  );

  return response.data;
};

export const usePostReactionCommentsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(postReactionCommentsMutation, {
    onSuccess: () => {
      queryClient.invalidateQueries(reactionsQueryKeys.all());
    },
  });
};
